var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraFe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 113,
    viewBox: "0 0 157 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2856 26.7145C50.6524 29.0813 50.6524 32.9187 48.2856 35.2855L27.5711 56L48.2856 76.7145C50.6524 79.0813 50.6524 82.9187 48.2856 85.2855C45.9187 87.6523 42.0814 87.6523 39.7146 85.2855L14.7146 60.2855C12.3477 57.9187 12.3477 54.0813 14.7146 51.7145L39.7146 26.7145C42.0814 24.3477 45.9187 24.3477 48.2856 26.7145Z",
    fill: "url(#paint0_linear_1642_4386)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.654 26.7145C106.287 29.0813 106.287 32.9187 108.654 35.2855L129.368 56L108.654 76.7145C106.287 79.0813 106.287 82.9187 108.654 85.2855C111.021 87.6523 114.858 87.6523 117.225 85.2855L142.225 60.2855C144.592 57.9187 144.592 54.0813 142.225 51.7145L117.225 26.7145C114.858 24.3477 111.021 24.3477 108.654 26.7145Z",
    fill: "url(#paint1_linear_1642_4386)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.253 25.3043C92.3987 26.4482 94.0214 29.9255 92.8776 33.0712L74.6957 83.0712C73.5519 86.2168 70.0745 87.8396 66.9289 86.6957C63.7832 85.5518 62.1604 82.0745 63.3043 78.9288L81.4861 28.9288C82.63 25.7832 86.1074 24.1604 89.253 25.3043Z",
    fill: "url(#paint2_linear_1642_4386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1642_4386",
    x1: 12.9395,
    y1: 24.9377,
    x2: 59.4106,
    y2: 125.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E3DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1642_4386",
    x1: 12.9395,
    y1: 24.9377,
    x2: 59.4106,
    y2: 125.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E3DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1642_4386",
    x1: 12.9395,
    y1: 24.9377,
    x2: 59.4106,
    y2: 125.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E3DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraFe);
export default __webpack_public_path__ + "static/media/GraFE.e49fa6fd5ade2ffffa49ba0cb41bc91b.svg";
export { ForwardRef as ReactComponent };